export default "__VITE_ASSET__07a5ec1e__"